export default "__VITE_ASSET__DQG5EJF2__"